export default "__VITE_ASSET__a5f6c3d6__"